import { plainToClass } from "class-transformer";
import { Fighter } from "../../../model/Dto/Fighter";
import { ApiRequest, RequestMethod } from "../../request";
import { IncreaseLevel } from "../../../model/Dto/Advancement";

type GetIncreaseLevelResponse = {
  success: boolean;
  increaseLevel: IncreaseLevel | undefined;
};

export async function getIncreaseLevel(id: string): Promise<GetIncreaseLevelResponse> {
  const URL = `/api/fighter/${id}/increase-level`;
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.GET);
  apiRequest.setUrl(URL);

  const response: any = await apiRequest.send();

  return {
    success: response.status === 200,
    increaseLevel:
      response.status === 200
        ? plainToClass(IncreaseLevel, response.data)
        : undefined,
  };
}
